import { Dispatch } from 'react';
import { IWicMappingsAction, IWicMappingsActions, IWicMappingsFindRequest } from './types';
import { get, post, put, remove } from '../../communication/httpClient';
import {
  CLOSE_DIALOG,
  ERROR_DETAILED_MAPPINGS,
  DETAILED_MAPPING_LOADED,
  ERROR_DATA_MAPPINGS,
  ERROR_DATA_SUBCATEGORIES,
  LOAD_MAPPINGS,
  LOAD_SUB_CATEGORIES,
  MAPPINGS_LOADED,
  RESET,
  RESET_MAPPINGS,
  SAVED_MAPPINGS,
  SET_AGENCY,
  SUB_CATEGORIES_LOADED,
  LOAD_DETAILED_MAPPING,
  DELETED_ITEMS,
  SET_DUPLICATED_KEY_OBJECT,
} from './actionTypes';

const getMappings = async (
  stateIdentifierCode: string,
  upcOrPluCode: string,
  dispatch: Dispatch<IWicMappingsAction>
) => {
  const { data, error } = await get(`/api/wic-mappings/${stateIdentifierCode}/${upcOrPluCode}`);
  if (data) {
    dispatch({
      type: DETAILED_MAPPING_LOADED,
      payload: {
        upcOrPluCode,
        data,
      },
    });
    return data;
  } else {
    dispatch({
      type: ERROR_DETAILED_MAPPINGS,
      payload: error,
    });
  }
};

export const getActions = (dispatch: Dispatch<IWicMappingsAction>): IWicMappingsActions => ({
  loadCategories: async (stateIdentifierCode: string) => {
    dispatch({
      type: LOAD_SUB_CATEGORIES,
    });
    const { data, error } = await get(`/api/wic-mappings/subcategory/${stateIdentifierCode}`);
    if (data) {
      dispatch({
        type: SUB_CATEGORIES_LOADED,
        payload: { stateIdentifierCode, data },
      });
    } else {
      dispatch({
        type: ERROR_DATA_SUBCATEGORIES,
        payload: error,
      });
    }
  },
  findMappings: async (request: IWicMappingsFindRequest) => {
    dispatch({
      type: LOAD_MAPPINGS,
    });
    const { data, error } = await post('/api/wic-mappings', request);
    if (data) {
      dispatch({
        type: MAPPINGS_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: ERROR_DATA_MAPPINGS,
        payload: error,
      });
    }
  },
  getMappings: async (stateIdentifierCode: string, upcOrPluCode: string) => {
    dispatch({
      type: LOAD_DETAILED_MAPPING,
    });
    await getMappings(stateIdentifierCode, upcOrPluCode, dispatch);
  },
  reset: () =>
    dispatch({
      type: RESET,
    }),
  closeDuplicateDialog: () => {
    dispatch({
      type: SET_DUPLICATED_KEY_OBJECT,
      payload: null,
    });
  },
  resetMappings: () => {
    dispatch({
      type: RESET_MAPPINGS,
    });
  },
  setCurrentAgency: (agency) => {
    dispatch({
      type: SET_AGENCY,
      payload: agency,
    });
  },
  closeDialog: () => {
    dispatch({
      type: CLOSE_DIALOG,
    });
  },
  saveMappings: async (upcOrPluCode, stateIdentifierCode, mappedData, itemsToDelete) => {
    if (mappedData.length === 0 && itemsToDelete.length === 0) {
      return;
    }
    dispatch({
      type: LOAD_DETAILED_MAPPING,
    });
    const requests: Array<Promise<any>> = [];
    if (mappedData.length > 0) {
      requests.push(
        put(`/api/wic-mappings/${stateIdentifierCode}`, {
          mappedProducts: mappedData,
        })
      );
    }
    if (itemsToDelete.length > 0) {
      requests.push(
        remove(`/api/wic-mappings/${stateIdentifierCode}`, {
          data: {
            mappedProductToDelete: itemsToDelete.map((item) => ({
              itemCode: item,
            })),
          },
        })
      );
    }
    const results = await Promise.all(requests);
    if (mappedData.length === 0) {
      const { error } = results[0];
      if (error) {
        dispatch({
          type: ERROR_DETAILED_MAPPINGS,
        });
        return;
      }
      dispatch({
        type: DELETED_ITEMS,
        payload: {
          upcOrPluCode,
          itemsToDelete,
        },
      });
    } else {
      results.forEach((result) => {
        const { error } = result;
        if (error) {
          dispatch({
            type: ERROR_DETAILED_MAPPINGS,
          });
        }
      });
      const { data } = results[0];
      if (data && Object.keys(data).length > 0) {
        dispatch({
          type: SET_DUPLICATED_KEY_OBJECT,
          payload: data,
        });
      }
      const getResult = await getMappings(stateIdentifierCode, upcOrPluCode, dispatch);
      if (getResult?.length > 0) {
        dispatch({
          type: SAVED_MAPPINGS,
          payload: upcOrPluCode,
        });
      }
    }
  },
  deleteMappings: async (upcOrPluCode, stateIdentifierCode, itemsToDelete) => {
    dispatch({
      type: LOAD_DETAILED_MAPPING,
    });
    const { data, error } = await remove(`/api/wic-mappings/${stateIdentifierCode}`, {
      data: {
        mappedProductToDelete: itemsToDelete.map((item) => ({
          itemCode: item,
        })),
      },
    });
    if (data || !error) {
      dispatch({
        type: DELETED_ITEMS,
        payload: {
          upcOrPluCode,
          itemsToDelete,
        },
      });
    } else {
      dispatch({
        type: ERROR_DETAILED_MAPPINGS,
        payload: error,
      });
    }
  },
});
